var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _g2, _path18, _g3, _path19, _g4, _path20, _g5, _path21, _path22, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJdQa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 127,
    viewBox: "0 0 150 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2919_22502)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.325 104.036L104.862 98.0601L92.7888 91.1665L91.0854 97.1719C90.2306 100.186 88.2198 102.74 85.4908 104.279L80.2869 107.213L99.176 118.04L100.712 117.156C105.293 114.519 107.581 109.171 106.325 104.036Z",
    fill: "#180C14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1999 91.1637L103.973 97.8854L105.414 103.777C106.649 108.824 104.4 114.08 99.8972 116.672L98.4625 117.498L79.9841 106.906L84.8771 104.148C87.6527 102.583 89.6978 99.9851 90.5673 96.9197L92.1999 91.1637Z",
    fill: "#E6DEDF",
    stroke: "#092256",
    strokeWidth: 0.405895
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5735 107.754V106.862L98.4803 117.564L99.3721 117.029V117.92L98.3019 118.634L79.5735 107.754Z",
    fill: "#180C14"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.329 111.322L89.5627 101.333C90.3296 100.173 90.8113 97.9444 91.8815 94.1987L104.367 101.333C105.906 106.939 106.334 109.46 106.329 111.322Z",
    fill: "black",
    fillOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.315 48.8593L73.9486 7.52466C68.3323 4.27172 61.3018 8.32432 61.3018 14.8147V68.2825C61.3018 71.2962 62.9116 74.0803 65.5234 75.5838L136.889 116.664C142.506 119.897 149.517 115.843 149.517 109.363V56.1493C149.517 53.1437 147.915 50.3657 145.315 48.8593Z",
    fill: "#180C14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9301 10.5155L140.351 51.8747C142.89 53.3448 144.453 56.056 144.453 58.9895V112.236C144.453 118.56 137.611 122.516 132.13 119.362L60.709 78.2572C58.1597 76.7901 56.5884 74.0728 56.5884 71.1315V17.6303C56.5884 11.2965 63.449 7.34153 68.9301 10.5155Z",
    fill: "#E6DEDF",
    stroke: "black",
    strokeWidth: 0.405895
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M136.45 52.965L74.2811 17.8835C68.6923 14.7298 61.7703 18.733 61.7166 25.15L61.3432 69.8197C61.3176 72.8762 62.9496 75.7068 65.6077 77.2161L128.15 112.728C133.766 115.916 140.734 111.86 140.734 105.402V60.302C140.734 57.2626 139.097 54.4588 136.45 52.965Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9473 16.7929L136.46 52.8621C139.096 54.359 140.724 57.1565 140.724 60.1877V105.738C140.724 112.187 133.775 116.245 128.159 113.075L64.6462 77.2278C61.9995 75.7339 60.3625 72.9303 60.3625 69.8912V24.1185C60.3625 17.6599 67.3312 13.6035 72.9473 16.7929ZM75.0876 18.3794L136.067 53.2935C138.689 54.7943 140.306 57.5838 140.306 60.6045V104.586C140.306 111.048 133.331 115.104 127.715 111.908L66.7353 77.2087C64.1029 75.7109 62.4772 72.9153 62.4772 69.8867V25.6904C62.4772 19.2187 69.4714 15.1638 75.0876 18.3794Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.519 67.9692L113.883 67.3474L74.8419 44.4255L74.4773 45.042L113.519 67.9692Z",
    fill: "#FFEBAF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.165 75.1304L113.524 74.5139L88.093 59.8259L87.7339 60.4477L113.165 75.1304Z",
    fill: "#FFEBAF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M112.794 83.3643L113.175 82.7585L100.636 74.8784L100.256 75.4842L112.794 83.3643Z",
    fill: "#FFEBAF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5417 72.6274L94.8955 72.0056L87.3746 67.7064L87.0154 68.3282L94.5417 72.6274Z",
    fill: "#FFEBAF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.878 60.4478L114.237 59.8259L97.4051 50.1554L97.0459 50.7772L113.878 60.4478Z",
    fill: "#FFEBAF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7491 84.4177C22.7531 85.1893 23.784 85.8884 24.8378 86.4962C23.3754 87.3446 21.913 88.195 20.4505 89.0435C19.3988 88.4357 18.3658 87.7387 17.3618 86.965C18.679 86.2016 20.4319 85.181 21.7491 84.4177Z",
    fill: "#333333"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8372 86.4959C25.8889 87.1037 26.9219 87.5974 27.928 87.9853L23.5428 90.5347C22.5367 90.1468 21.5037 89.651 20.45 89.0432C21.9124 88.1948 23.3748 87.3443 24.8372 86.4959Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2919_22502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 87,
    width: 6,
    height: 25
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8767 106.543C27.8725 107.634 27.5427 108.285 27.0345 108.582L22.6472 111.129C23.1554 110.834 23.4874 110.183 23.4915 109.09C23.5081 102.906 23.5247 96.7204 23.5434 90.5347L27.9285 87.9854C27.912 94.1711 27.8933 100.357 27.8767 106.543Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2919_22502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8767 106.543C27.8725 107.634 27.5427 108.285 27.0345 108.582L22.6472 111.129C23.1554 110.834 23.4874 110.183 23.4915 109.09C23.5081 102.906 23.5247 96.7204 23.5434 90.5347L27.9285 87.9854C27.912 94.1711 27.8933 100.357 27.8767 106.543Z",
    fill: "#180C14"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2919_22502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 86,
    width: 7,
    height: 26
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5433 90.5347C23.5246 96.7204 23.508 102.906 23.4914 109.09C23.4831 111.459 21.9356 111.749 20.3902 110.857C18.8449 109.965 17.3036 107.889 17.3098 105.522C17.3264 99.3362 17.3451 93.1505 17.3617 86.9647C18.3657 87.7385 19.3987 88.4355 20.4504 89.0432C21.5042 89.651 22.5372 90.1468 23.5433 90.5347Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2919_22502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5128 105.522C17.5068 107.806 18.9994 109.82 20.4917 110.681C21.2415 111.114 21.9413 111.229 22.4351 111.011C22.9105 110.8 23.2844 110.236 23.2885 109.089L23.2886 109.043C23.305 102.921 23.3214 96.7971 23.3399 90.6732C22.3645 90.2891 21.3658 89.8055 20.349 89.219L20.3489 89.219C19.4024 88.672 18.4715 88.0537 17.5635 87.3731C17.5556 90.33 17.5471 93.287 17.5387 96.2439C17.5299 99.3367 17.5211 102.43 17.5128 105.522ZM17.5128 105.522L17.3098 105.522L17.5128 105.522Z",
    fill: "#E6DEDF",
    stroke: "black",
    strokeWidth: 0.405895
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2919_22502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 41,
    width: 37,
    height: 50
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9571 43.8834C19.8044 40.9088 15.135 40.6329 11.7642 42.5932L7.37695 45.1405C10.7498 43.1823 15.4171 43.4582 20.5719 46.4328C30.8109 52.3447 39.0855 66.6764 39.0523 78.4442C39.0357 84.2897 36.9717 88.4031 33.6445 90.3364L38.0297 87.787C41.359 85.8537 43.4209 81.7403 43.4375 75.8948C43.4728 64.1291 35.1982 49.7974 24.9571 43.8834Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2919_22502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9571 43.8834C19.8044 40.9088 15.135 40.6329 11.7642 42.5932L7.37695 45.1405C10.7498 43.1823 15.4171 43.4582 20.5719 46.4328C30.8109 52.3447 39.0855 66.6764 39.0523 78.4442C39.0357 84.2897 36.9717 88.4031 33.6445 90.3364L38.0297 87.787C41.359 85.8537 43.4209 81.7403 43.4375 75.8948C43.4728 64.1291 35.1982 49.7974 24.9571 43.8834Z",
    fill: "#180C14"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2919_22502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 43,
    width: 39,
    height: 49
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5726 46.4327C30.8116 52.3446 39.0862 66.6763 39.053 78.444C39.0239 89.0004 32.3176 93.9063 23.5431 90.5354C22.537 90.1475 21.504 89.6518 20.4502 89.044C19.3985 88.4362 18.3655 87.7392 17.3615 86.9655C8.59737 80.2135 1.94078 67.591 1.96982 57.0347C2.00301 45.2669 10.3315 40.5208 20.5726 46.4327Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2919_22502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4854 86.8047L17.4854 86.8047C18.4828 87.5734 19.5084 88.2653 20.5518 88.8683C21.5972 89.4712 22.6207 89.9623 23.6161 90.3461C27.9565 92.0134 31.7478 91.6219 34.4543 89.5513C37.1649 87.4774 38.8356 83.6826 38.85 78.4435C38.8665 72.6039 36.8203 66.114 33.4891 60.3439C30.1579 54.5738 25.5526 49.5424 20.4711 46.6084C15.3874 43.6737 10.8255 43.4098 7.54373 45.2801C4.26247 47.1501 2.18924 51.1946 2.17277 57.0352C2.14392 67.5219 8.76582 80.0871 17.4854 86.8047Z",
    fill: "#E6DEDF",
    stroke: "black",
    strokeWidth: 0.405895
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2919_22502",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 48,
    width: 31,
    height: 39
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4405 50.1926C28.5678 54.8847 35.1331 66.2605 35.1083 75.5992C35.0813 84.938 28.4724 88.705 20.3451 84.0128C12.2178 79.3206 5.65036 67.9449 5.67733 58.6082C5.70222 49.2674 12.3132 45.5004 20.4405 50.1926Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2919_22502)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M20.4405 50.1926C28.5678 54.8847 35.1331 66.2605 35.1083 75.5992C35.0813 84.938 28.4724 88.705 20.3451 84.0128C12.2178 79.3206 5.65036 67.9449 5.67733 58.6082C5.70222 49.2674 12.3132 45.5004 20.4405 50.1926Z",
    fill: "white"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M7.48853 51.4062C6.54274 53.149 6.17573 54.2468 5.8109 56.4392C5.40163 65.4656 7.78778 70.8197 15.6371 80.6452C17.6576 82.4272 18.8041 83.2991 20.9097 84.2402C10.2477 72.4734 7.03613 65.4389 7.48853 51.4062Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M34.8105 78.7273C32.5178 66.7661 29.5307 60.7181 21.629 50.9263L24.7446 53.3229C32.2309 61.6329 34.2318 66.5507 35.2898 75.6116L34.8105 78.7273Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2919_22502"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149.434,
    height: 126.605,
    fill: "white",
    transform: "translate(0.0834961 0.200195)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJdQa);
export default __webpack_public_path__ + "static/media/jd-qa.2bad376227a61f59b570b01201717a85.svg";
export { ForwardRef as ReactComponent };